(function () {
  const grid = document.querySelector('.gm-gallery-page .gm-grid');
  if (!grid) return;
  const items = Array.prototype.slice.call(grid.querySelectorAll('.gm-grid-item'));
  let i = 0, box = null, lastFocus = null;

  // Icons are SVG paths, not text glyphs: the theme font drew '‹' and '›' as
  // thin strokes that vanished over a bright photo.
  const ICONS = {
    close: 'M6 6l12 12M18 6L6 18',
    left: 'M14 6l-6 6 6 6',
    right: 'M10 6l6 6-6 6',
    prev: 'M15 5l-7 7 7 7',
    next: 'M9 5l7 7-7 7'
  };

  function makeButton(cls, label, icon) {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = cls;
    b.setAttribute('aria-label', label);
    b.innerHTML = '<svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true" ' +
      'focusable="false"><path d="' + ICONS[icon] + '" fill="none" stroke="currentColor" ' +
      'stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    return b;
  }

  // Only controls that can take focus: a strip arrow is hidden when the strip
  // fits, and disabled at either end.
  function buttons() {
    return box ? Array.prototype.slice.call(box.querySelectorAll('button')).filter(function (b) {
      return !b.disabled && b.offsetParent !== null;
    }) : [];
  }

  function open(idx) {
    // Re-entrancy guard: the grid links stay focusable behind the overlay, so a
    // second activation would stack another overlay and another keydown listener.
    if (box) return;
    lastFocus = document.activeElement;
    i = idx;
    box = document.createElement('div');
    box.className = 'gm-lb';
    // Dialog semantics so assistive tech announces this as a modal rather than
    // as loose buttons appended to the end of the page.
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Gallery image viewer');
    const closeBtn = makeButton('gm-lb__close', 'Close', 'close');
    const prevBtn  = makeButton('gm-lb__prev', 'Previous image', 'prev');
    const nextBtn  = makeButton('gm-lb__next', 'Next image', 'next');
    const img = document.createElement('img');
    img.alt = '';
    const count = document.createElement('div');
    count.className = 'gm-lb__count';
    count.setAttribute('aria-hidden', 'true');   // the dialog label already says it
    // Thumbnail bar under the photo: one button per image, scrolled sideways by
    // finger, trackpad or its own arrows.
    const bar = document.createElement('div');
    bar.className = 'gm-lb__bar';
    const stripPrev = makeButton('gm-lb__strip-prev', 'Scroll thumbnails left', 'left');
    const stripNext = makeButton('gm-lb__strip-next', 'Scroll thumbnails right', 'right');
    const strip = document.createElement('div');
    strip.className = 'gm-lb__strip';
    items.forEach(function (a, n) {
      const t = document.createElement('button');
      t.type = 'button';
      t.className = 'gm-lb__thumb';
      t.setAttribute('aria-label', 'Show image ' + (n + 1) + ' of ' + items.length);
      const src = a.querySelector('img');
      const ti = document.createElement('img');
      ti.alt = '';
      ti.loading = 'lazy';
      ti.src = (src && (src.currentSrc || src.getAttribute('src'))) || a.getAttribute('href');
      t.appendChild(ti);
      t.addEventListener('click', function () { i = n; render(); });
      strip.appendChild(t);
    });
    bar.appendChild(stripPrev);
    bar.appendChild(strip);
    bar.appendChild(stripNext);
    box.appendChild(img);
    box.appendChild(bar);
    box.appendChild(closeBtn);
    box.appendChild(prevBtn);
    box.appendChild(nextBtn);
    box.appendChild(count);
    if (items.length < 2) {
      prevBtn.hidden = true; nextBtn.hidden = true; count.hidden = true; bar.hidden = true;
    }
    stripPrev.addEventListener('click', function () { page(-1); });
    stripNext.addEventListener('click', function () { page(1); });
    strip.addEventListener('scroll', stripArrows, { passive: true });
    // A mouse wheel scrolls vertically; turn it sideways over the strip.
    strip.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) { strip.scrollLeft += e.deltaY; e.preventDefault(); }
    }, { passive: false });
    document.body.appendChild(box);
    document.body.style.overflow = 'hidden';
    render();
    box.addEventListener('click', function (e) {
      // contains(): a click on the icon inside a button targets the svg, not the button.
      const t = e.target;
      if (t === box || closeBtn.contains(t)) close();
      else if (prevBtn.contains(t)) move(-1);
      else if (nextBtn.contains(t)) move(1);
    });
    // Swipe on phones: a horizontal drag of 40px or more changes image; anything
    // smaller is a tap, and a mostly vertical drag is left alone.
    let x0 = null, y0 = null;
    box.addEventListener('touchstart', function (e) {
      // Dragging along the thumbnail bar scrolls it; that is not a photo swipe.
      if (e.touches.length !== 1 || bar.contains(e.target)) { x0 = null; return; }
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      const t = e.changedTouches[0];
      const dx = t.clientX - x0, dy = t.clientY - y0;
      x0 = null;
      if (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy)) move(dx < 0 ? 1 : -1);
    });
    document.addEventListener('keydown', keys);
    closeBtn.focus();
  }

  function render() {
    const a = items[i];
    const img = box.querySelector('img');
    img.src = a.getAttribute('href');
    const srcImg = a.querySelector('img');
    img.alt = (srcImg && srcImg.alt) || '';
    box.setAttribute('aria-label',
      'Gallery image viewer, image ' + (i + 1) + ' of ' + items.length);
    box.querySelector('.gm-lb__count').textContent = (i + 1) + ' / ' + items.length;
    const strip = box.querySelector('.gm-lb__strip');
    const thumbs = strip.children;
    for (let n = 0; n < thumbs.length; n++) {
      if (n === i) thumbs[n].setAttribute('aria-current', 'true');
      else thumbs[n].removeAttribute('aria-current');
    }
    // Centre the current thumbnail in the bar. scrollTo on the strip itself, not
    // scrollIntoView, which would also scroll the page behind the overlay.
    const cur = thumbs[i];
    if (cur) {
      strip.scrollTo({
        left: cur.offsetLeft - (strip.clientWidth - cur.offsetWidth) / 2,
        behavior: 'smooth'
      });
    }
    stripArrows();
  }

  function page(d) {
    const strip = box.querySelector('.gm-lb__strip');
    strip.scrollBy({ left: d * strip.clientWidth * 0.8, behavior: 'smooth' });
  }

  // Strip arrows show only when the thumbnails overflow, and grey out at the ends.
  function stripArrows() {
    if (!box) return;
    const strip = box.querySelector('.gm-lb__strip');
    const prev = box.querySelector('.gm-lb__strip-prev');
    const next = box.querySelector('.gm-lb__strip-next');
    const overflow = strip.scrollWidth > strip.clientWidth + 1;
    prev.hidden = next.hidden = !overflow;
    prev.disabled = strip.scrollLeft <= 1;
    next.disabled = strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 1;
  }

  function move(d) { i = (i + d + items.length) % items.length; render(); }

  function close() {
    if (!box) return;
    box.remove(); box = null;
    document.body.style.overflow = '';
    document.removeEventListener('keydown', keys);
    // Return focus to the thumbnail that opened it, or the user is dumped at the
    // top of the document with no idea where they were.
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    lastFocus = null;
  }

  // Keep Tab inside the dialog — without this, tabbing walks the (visually
  // hidden but still focusable) thumbnails behind the overlay.
  function trap(e) {
    const f = buttons();
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (!box.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
    else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function keys(e) {
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowRight') move(1);
    else if (e.key === 'ArrowLeft') move(-1);
    else if (e.key === 'Tab') trap(e);
  }

  items.forEach(function (a, idx) {
    a.addEventListener('click', function (e) { e.preventDefault(); open(idx); });
  });
})();
